import * as z from "zod";

export const listLinnworksLocations = {
  name: "listLinnworksLocations" as const,
  input: z.object({}),
  output: z.object({
    locations: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        // WMS locations have a fixed bin list; others take free-text bins.
        isWarehouseManaged: z.boolean(),
      }),
    ),
  }),
};
